import { render, staticRenderFns } from "./TestingCenterDay.vue?vue&type=template&id=3577ea2f&"
import script from "./TestingCenterDay.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports